import { createRouter, createWebHistory } from 'vue-router';
//import Home from './views/Home.vue';
import About from './views/About.vue';
import Product from './views/Product.vue';
import appmain from './views/appmain.vue';
 
// ·������ { path: '/', component: Home },
const routes = [
	{ path: '/', component: appmain },
	{ path: '/about', component: About },
	{ path: '/product', component: Product }
];
 
// ����routerʵ��
const router = createRouter({
  history: createWebHistory(),
  routes
});
 
export default router;